import { openPanel } from '../helpers/utilities';

interface IAccordionConfig {
  classNames: IAccordionClassNames,
  selectors: IAccordionSelectors,
  nodeLists: IAccordionNodeLists,
  htmlElements: IAccordionHTMLElements
}

interface IAccordionSelectors {
  panel: string,
  btn: string
}

interface IAccordionClassNames {
  active: string
}

interface IAccordionNodeLists {
  accordions: NodeList,
  btns: NodeList
}

interface IAccordionHTMLElements {
  accordion: HTMLElement
}

class Accordion {
  private config:IAccordionConfig;

  constructor() {
    this.config = {
      htmlElements: {
        accordion: null
      },
      nodeLists: {
        accordions: document.querySelectorAll('[data-accordion]'),
        btns: document.querySelectorAll('[data-accordion-btn]')
      },
      classNames: {
        active: 'accordion--active'
      },
      selectors: {
        btn: '[data-accordion-btn]',
        panel: '[data-accordion-panel]',
      }
    };
  }

  init() {
    this.load();
    this.addEventListeners();
  }

  public load() {
    this.config.nodeLists.accordions.forEach((htmlElement: HTMLElement) => this.openPanels(htmlElement));
  }

  private addEventListeners() {
    this.config.nodeLists.accordions.forEach((htmlElement: HTMLElement) => htmlElement.addEventListener('click', this.handleAccordionClick.bind(this, htmlElement)));
  }

  private openPanels(htmlElement:HTMLElement) {
    openPanel(htmlElement.querySelector(this.config.selectors.panel), htmlElement.classList.contains(this.config.classNames.active));
  }

  private handleAccordionClick(htmlElement: HTMLElement, event: Event) {
    const target = event.target as HTMLElement;
    const btn = target.closest(this.config.selectors.btn) as HTMLElement;
    if (btn && typeof btn.dataset.accordionBtn === 'string') {
      this.toggleActiveClassName(htmlElement);
      this.openPanels(htmlElement);
    }
  }

  private toggleActiveClassName(htmlElement: HTMLElement) {
    if (htmlElement.classList.contains(this.config.classNames.active)) {
      htmlElement.classList.remove(this.config.classNames.active);
    } else {
      htmlElement.classList.add(this.config.classNames.active);
    }
  }
}

export default new Accordion();